import React from 'react';

/**
 * Placeholder chrome while a calculator-family route chunk loads.
 * Mirrors the navy hero + tab bar layout so navigation feels continuous.
 */
export const CalculatorRouteSkeleton: React.FC = () => (
  <div className="mt-6 animate-pulse" role="status" aria-live="polite" aria-label="Loading calculator">
    <div
      className="px-6 pt-5 pb-6 rounded-t-2xl"
      style={{ background: 'linear-gradient(135deg, #0F1F38 0%, #1A2F50 60%, #243A62 100%)' }}
    >
      <div className="h-9 w-2/3 max-w-md rounded-md bg-navy-700/80 mb-3" />
      <div className="h-4 w-full max-w-xl rounded-md bg-navy-700/60 mb-2" />
      <div className="h-4 w-4/5 max-w-lg rounded-md bg-navy-700/50" />
    </div>

    <div className="flex flex-col rounded-b-2xl border-b border-navy-700" style={{ background: '#1A2F50' }}>
      <div className="flex items-center justify-between px-6 pt-2 pb-3">
        <div className="flex items-end gap-2">
          <div className="h-10 w-28 rounded-t-xl bg-navy-700/70" />
          <div className="h-10 w-28 rounded-t-xl bg-gold-500/40" />
          <div className="h-10 w-24 rounded-t-xl bg-navy-700/50" />
        </div>
        <div className="flex gap-2">
          <div className="h-9 w-9 rounded-md bg-navy-700/60" />
          <div className="h-9 w-9 rounded-md bg-navy-700/60" />
          <div className="h-9 w-9 rounded-md bg-navy-700/60" />
        </div>
      </div>
    </div>

    <div className="px-6 py-8 space-y-4 bg-white rounded-b-2xl border border-stone-border/80 border-t-0">
      <div className="h-5 w-40 rounded-md bg-stone-200" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="space-y-3">
          <div className="h-4 w-full rounded-md bg-stone-100" />
          <div className="h-4 w-5/6 rounded-md bg-stone-100" />
          <div className="h-10 w-full rounded-lg bg-stone-100" />
          <div className="h-10 w-full rounded-lg bg-stone-100" />
        </div>
        <div className="hidden lg:block h-48 rounded-xl bg-stone-100" />
      </div>
    </div>
  </div>
);
